import { IMessageText, MESSAGE_TEXTS_SCHEMA } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { ImportExportGateway, IGetGateway, ISaveGateway } from '../gateways';
import { MessageRestCallBuilder } from '../../../builder/rest/message-rest-call.builder';

export class MessageGateway
  extends ImportExportGateway<IMessageText[], FormData>
  implements
    IGetGateway<null, IApiResponse<IMessageText[]>>,
    ISaveGateway<IMessageText[], IApiResponse<IMessageText[]>>
{
  private readonly restCallBuilder: MessageRestCallBuilder<
    IMessageText[],
    string
  > = new MessageRestCallBuilder<IMessageText[], string>([], '');

  get(): Observable<IApiResponse<IMessageText[]>> {
    return this.restCallBuilder
      .get('/messages/')
      .validate(API_RESPONSE_SCHEMA(MESSAGE_TEXTS_SCHEMA))
      .handleErrors()
      .build();
  }

  save(query: IMessageText[]): Observable<IApiResponse<IMessageText[]>> {
    return this.restCallBuilder
      .post('/messages/', query)
      .validate(API_RESPONSE_SCHEMA(MESSAGE_TEXTS_SCHEMA))
      .handleErrors()
      .build();
  }

  download(): Observable<IApiResponse<string>> {
    return this.restCallBuilder
      .getDownloadableContent('/messages/download')
      .handleErrors()
      .buildDownloadContent();
  }

  upload(query: FormData): Observable<IApiResponse<IMessageText[]>> {
    return this.restCallBuilder
      .upload('/messages/upload/', query)
      .handleErrors()
      .build();
  }
}
